import { useEffect } from 'react';

/*
 * Recebe o ref de algum elemento na tela e uma função de callback que
 * será disparada quando clicar em qualquer elemento fora do elemento passado.
 */

export default function useOutsideClick(ref, callback = () => {}) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
}
